import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import NotFound from "../../components/not-found/NotFound";
import ViewListRoundedIcon from "@mui/icons-material/ViewListRounded";
import { Link, useSearchParams } from "react-router-dom";
import IconButton from "../../components/Button/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BlockIcon from "@mui/icons-material/Block";
import Switch from "../../components/Switch/Switch";
import { SecondaryButton } from "../../components/Button/Button";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { DatePicker, Select } from "../../components/Form";
import { toast } from "sonner";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useDebounce from "../../hooks/useDebounce";
// import { getOrderApi } from '../../services/orderManagement'
import { IoSearch } from "react-icons/io5";
import profileImage from "../../Assests/image/profile_not_found.png";
import { user } from "../../routes/route";
import { getLocalStorage, setLocalStorage } from "../../config/config";
import {
  getDeletedUserListApi,
  getUserListApi,
  logoutUserFromAllDevice,
} from "../../services/userManagement";
import findSerialNumber from "../../utils/findSerialNumber";

import { toastMessage } from "../../utils/toastMessage";
import { fatchCategoryApi } from "../../services/categoryManagement";
import { charLimit } from "../../utils/charLimit";
import common from "../../routes/common";
import UserStatus from "./UserStatus";
import { dateFormat, dateFormatUtc } from "../../utils/dateFormat";
import { gender } from "../../utils/genderList";
import scrollToUp from "../../utils/scrollToUp";
import { CapitalizeFirstWord } from "../../utils/CapitalizeFirstWord";
import Loader from "../../comman/Loader";
import useDownloadWithPassword from "../../hooks/useDownloadWithPassword";
import csv from "../../Assests/image/csv.svg";
import useButtonLoader from "../../hooks/UseButtonLoader";
import ModalBox from "../../components/modal/ModalBox";
import { FormControl, InputLabel, Select as MuiSelect, MenuItem, TextField, Typography } from "@mui/material";

const { USER_DETAIL, USER_DELETE } = user;
const { NOT_FOUND } = common;

// console.log('Gender', gender)

const DeleteUser = () => {
  let URL = process.env.REACT_APP_API_URL;
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  let pageLimit = +searchParam.get("limit") || 10;

  const [search, setSearch] = useState(
    getLocalStorage("deletedUserList", "search") || ""
  );
  const debounceValue = useDebounce(search || "", 300);
  const [total, setTotal] = useState(0);
  const [userList, setUserList] = useState([]);
  const [problemList, setProblemList] = useState([]);
  const [statusModal, setStatusModal] = useState(false);
  const [statusValue, setStatusValue] = useState("");
  const [statusId, setStatusId] = useState("");
  const [logoutUserModel, setLogoutUserModel] = useState(false);
  const [buttonref, buttonLoader] = useButtonLoader("Logout");

  const genderValue = searchParam.get("gender") || "";
  const problemValue = searchParam.get("problem") || "";
  
  // Time range filter states
  const [timeRange, setTimeRange] = useState(searchParam.get("timeRange") || "");
  const [timeRangeStartDate, setTimeRangeStartDate] = useState(searchParam.get("timeRangeStartDate") || "");
  const [timeRangeEndDate, setTimeRangeEndDate] = useState(searchParam.get("timeRangeEndDate") || "");
  
  // Sort filter states
  const [sortBy, setSortBy] = useState(searchParam.get("sortBy") || "");
  
  // Time range options
  const timeRangeOptions = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "last7days", label: "Last 7 Days" },
    { value: "last30days", label: "Last 30 Days" },
    { value: "thisMonth", label: "This Month" },
    { value: "lastMonth", label: "Last Month" },
    { value: "custom", label: "Custom Range" }
  ];

  // Sort options
  const sortOptions = [
    { value: "", label: "Default Sort" },
    { value: "wallet_desc", label: "Wallet (High to Low)" },
    { value: "wallet_asc", label: "Wallet (Low to High)" },
    { value: "name_asc", label: "Name (A to Z)" },
    { value: "name_desc", label: "Name (Z to A)" },
    { value: "registration_desc", label: "Registration (Newest)" },
    { value: "registration_asc", label: "Registration (Oldest)" }
  ];

  useEffect(() => {
    setLocalStorage("deletedUserList", "search", search);
  }, [search]);

  const handleLogoutHandler = async () => {
    try {
      buttonLoader(true);
      const sendData = { userId: statusId };
      const { data } = await logoutUserFromAllDevice(sendData);
      if (data.code === 200) {
        console.log("Date", data);
        logoutCloseModel();
      } else {
        toastMessage(data.message, "error", "userList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      buttonLoader(false);
    }
  };

  // handle all hooks
  const { loading, requestDownload, DownloadPasswordModal } = useDownloadWithPassword();
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const handleExcelDownload = () => {
    try {
      const url = `${URL}/admin/user/deletedDownload`;
      const params = {
        filter: {}
      };
      
      // Add all current filters to the export
      if(search) {
        params.filter.search = search;
      }
      if (genderValue) {
        params.filter.gender = genderValue;
      }
      if (problemValue) {
        params.filter.problems = problemValue;
      }
      if (timeRange) {
        params.filter.timeRange = timeRange;
      }
      if (timeRangeStartDate) {
        params.filter.timeRangeStartDate = timeRangeStartDate;
      }
      if (timeRangeEndDate) {
        params.filter.timeRangeEndDate = timeRangeEndDate;
      }
      
      requestDownload(url, `deleted-user-excel-file-${dateFormat(new Date())}`, params);
    } catch (e) {
      console.log(e.message);
    }
  };

  //   //*********Logout handler function********* */
  //   const userLogoutHandler = (id) => {
  //     setStatusId(id)
  //     setLogoutUserModel(true)
  //   }

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };

  const handlePageLimitChange = (event) => {
    const newLimit = parseInt(event.target.value);
    searchParam.set("limit", newLimit);
    setSearchParam(searchParam);
  };

  //*********Handel refresh icon********* */
  const refreshHandler = (event) => {
    setSearch("");
    setTimeRange("");
    setTimeRangeStartDate("");
    setTimeRangeEndDate("");
    setSortBy("");
    searchParam.delete("limit");
    searchParam.delete("page");
    searchParam.delete("gender");
    searchParam.delete("problem");
    searchParam.delete("timeRange");
    searchParam.delete("timeRangeStartDate");
    searchParam.delete("timeRangeEndDate");
    searchParam.delete("sortBy");
    setSearchParam(searchParam);
    getDeletedUserList(debounceValue);
  };

  const applyFilter = () => {
    // Update URL parameters for time range
    if (timeRange) {
      searchParam.set("timeRange", timeRange);
    } else {
      searchParam.delete("timeRange");
    }
    if (timeRangeStartDate) {
      searchParam.set("timeRangeStartDate", timeRangeStartDate);
    } else {
      searchParam.delete("timeRangeStartDate");
    }
    if (timeRangeEndDate) {
      searchParam.set("timeRangeEndDate", timeRangeEndDate);
    } else {
      searchParam.delete("timeRangeEndDate");
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
    getDeletedUserList(debounceValue);
  };

  // gender handler
  const genderHandler = (value) => {
    if (genderValue === value) {
      searchParam.delete("gender");
    } else {
      searchParam.set("gender", value);
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };

  // Problem handler
  const problemValueHandler = (value) => {
    if (problemValue === value) {
      searchParam.delete("problem");
    } else {
      searchParam.set("problem", value);
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };

  // Time range handler
  const handleTimeRangeChange = (value) => {
    setTimeRange(value);
    if (value !== 'custom') {
      setTimeRangeStartDate("");
      setTimeRangeEndDate("");
    }
  };

  // Time range date change handler
  const handleTimeRangeDateChange = (type, value) => {
    if (type === 'start') {
      setTimeRangeStartDate(value);
    } else {
      setTimeRangeEndDate(value);
    }
  };

  // Sort handler
  const handleSortChange = (value) => {
    setSortBy(value);
    if (value) {
      searchParam.set("sortBy", value);
    } else {
      searchParam.delete("sortBy");
    }
    searchParam.delete("page");
    setSearchParam(searchParam);
  };
  //------------------usre-listing-Api----------------------------------
  const getDeletedUserList = async (debounceValue) => {
    try {
      showLoader();
      const sendData = {
        page: `${activePage}`,
        limit: `${pageLimit}`,
        filter: {}
      };

      if (debounceValue) {
        sendData.page = String(activePage)
        sendData.limit = String(pageLimit)
        sendData.search = debounceValue
        setSearchParam(searchParam)
      }
      if (problemValue) {
        sendData.filter.problems = problemValue;
      }
      if (genderValue) {
        sendData.filter.gender = genderValue;
      }
      
      // Time range filters
      if (timeRange) {
        sendData.filter.timeRange = timeRange;
      }
      if (timeRangeStartDate) {
        sendData.filter.timeRangeStartDate = timeRangeStartDate;
      }
      if (timeRangeEndDate) {
        sendData.filter.timeRangeEndDate = timeRangeEndDate;
      }
      if (sortBy) {
        sendData.sortBy = sortBy;
      }

      const { data } = await getDeletedUserListApi(sendData);
      if (data.code === 200) {
        setUserList(data?.result?.list || []);
        setTotal(data?.result?.total || 0);
      } else {
        setUserList([]);
        setTotal(0);
        toastMessage(data.message, "error", "userList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  const closeModel = () => {
    setStatusModal(false);
    setStatusValue("");
    setStatusId("");
  };

  const logoutCloseModel = () => {
    setLogoutUserModel(false);
    setStatusId("");
  };

  // problem list handler function

  const fetchProblemHandler = async () => {
    try {
      showLoader();
      const { data } = await fatchCategoryApi();
      if (data.code === 200) {
        setProblemList(data?.result?.categoryList || []);
      } else {
        setProblemList([]);
        toastMessage(data.message, "error", "categoryList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  // useEffect(() => {
  //   if (debounceValue) {
  //     searchParam.set('query', debounceValue)
  //   } else {
  //     searchParam.delete('query')
  //   }
  //   if (activePage === 1) {
  //     searchParam.delete('page')
  //   }
  //   setSearchParam(searchParam)
  //   getOrder(activePage, debounceValue)
  // }, [searchParam, debounceValue])

  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParam.delete("page");
    }
    if (!genderValue) {
      searchParam.delete("gender");
    }
    if (!problemValue) {
      searchParam.delete("problem");
    }
    if (!timeRange) {
      searchParam.delete("timeRange");
    }
    if (!timeRangeStartDate) {
      searchParam.delete("timeRangeStartDate");
    }
    if (!timeRangeEndDate) {
      searchParam.delete("timeRangeEndDate");
    }
    if (!sortBy) {
      searchParam.delete("sortBy");
    }
    setSearchParam(searchParam);
    getDeletedUserList(debounceValue);
  }, [searchParam, debounceValue]);

  useEffect(() => {
    fetchProblemHandler();
  }, []);
  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            {/* <div className="user_management_heading"> */}
            <h4 className="Title">Deleted User</h4>
            
            <div className="block_user_button">
              <span
                className="user_management_excel"
                onClick={handleExcelDownload}
              >
                {loading ? (
                  <Loader />
                ) : (
                  <div className="csv-image-wrapper">
                    <figure>
                      <img src={csv} alt="csv file download" />
                    </figure>
                  </div>
                )}
              </span>
            </div>
          </div>
          <div className="FilterBox FilterArea">
            <div className="form-group search_lg_size userSearch">
              <input
                type="search"
                className={`form-control ${search && "active"}`}
                placeholder="Search"
                value={search || ""}
                style={{ "--color": "#FF8989" }}
                onChange={(e) => setSearch(e.target.value)}
              />
              <span className="user_search_icon">
                <IoSearch />
              </span>
            </div>  

              {/* Time Range Filter */}
              <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel>Time Range</InputLabel>
                  <MuiSelect
                    value={timeRange}
                    onChange={(e) => handleTimeRangeChange(e.target.value)}
                    label="Time Range"
                  >
                    <MenuItem value="">
                      <em>All Time Ranges</em>
                    </MenuItem>
                    {timeRangeOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </MuiSelect>
                </FormControl>
              </div>
              
              {timeRange === 'custom' && (
                <>
                  <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                    <TextField
                      size="small"
                      type="date"
                      variant="outlined"
                      label="Start Date"
                      value={timeRangeStartDate}
                      onChange={(e) => handleTimeRangeDateChange('start', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                  <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                    <TextField
                      size="small"
                      type="date"
                      variant="outlined"
                      label="End Date"
                      value={timeRangeEndDate}
                      onChange={(e) => handleTimeRangeDateChange('end', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                </>
              )}

              {/* Gender-Filter */}
              <div className="form-group select_sm_width">
                <Select
                  className={`form-control ${genderValue && "active"}`}
                  value={genderValue || ""}
                  onChange={(e) => genderHandler(e.target.value)}
                >
                  <option value="">Gender</option>
                  {gender &&
                    gender.length > 0 &&
                    gender.map((gender, index) => {
                      return (
                        <option value={gender.value} key={gender.id}>
                          {gender.name}
                        </option>
                      );
                    })}
                </Select>
              </div>

              {/* Sort Filter */}
              <div className="form-group select_sm_width">
                <Select
                  className={`form-control ${sortBy && "active"}`}
                  value={sortBy || ""}
                  onChange={(e) => handleSortChange(e.target.value)}
                >
                  {sortOptions.map((option) => (
                    <option value={option.value} key={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Select>
              </div>

              {/* Problem filter */}
              <div className="form-group select_sm_width">
                <Select
                  className={`form-control ${problemValue && "active"}`}
                  value={problemValue || ""}
                  onChange={(e) => problemValueHandler(e.target.value)}
                >
                  <option value={""} key={1}>
                    Problem
                  </option>
                  {problemList &&
                    problemList.length > 0 &&
                    problemList.map((problem, index) => {
                      return (
                        <option value={problem._id} key={problem._id}>
                          {charLimit(problem.title, 20)}
                        </option>
                      );
                    })}
                </Select>
              </div>

             <div className="form-group refresh_button" style={{ minWidth: '120px', flex: '0 0 auto', display: 'flex', gap: '10px' }}>
                                <SecondaryButton onClick={applyFilter}>
                                    Apply
                                </SecondaryButton>
                                <SecondaryButton onClick={refreshHandler}>
                                    Clear
                                </SecondaryButton>
                            </div>
          </div>
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  {/* <th>User Id</th> */}
                  <th>Profile</th>
                  <th>Name</th>
                  <th>User Id</th>
                  <th>Phone Number</th>
                  {/* <th>Status</th> */}
                  <th>Email</th>
                  <th>Gender</th>
                  <th>Registration Date</th>
                  <th>Details</th>
                  {/* <th className="text-center"> Action </th>
                  <th>Logout from all Device</th> */}
                </tr>
              </thead>
              <tbody>
                {userList.length > 0 ? (
                  userList.map((user, index) => {
                    console.log(" deleted user====>", user)
                    return (
                      <React.Fragment key={index}>
                        <tr>
                          <td>{findSerialNumber(index, activePage, pageLimit)}</td>
                          {/* <td>{user?._id}</td> */}
                          <td className="user_profile_image">
                            <img
                              src={user.profileImage || profileImage}
                              alt={`${user.name} profile image`}
                            />
                          </td>
                          <td>{user?.name || "---"}</td>
                          <td>{user?.userId || "---"}</td>
                          <td>{user.mobile || "---"}</td>

                          <td>{user.email || "---"}</td>
                          <td>
                            {user.gender
                              ? CapitalizeFirstWord(user.gender)
                              : "---"}
                          </td>
                          <td>{dateFormat(user.createdAt) || "---"}</td>
                          <td>
                            <div className="action_button">
                              <Link to={`${USER_DETAIL}/${user._id}`}>
                                <IconButton
                                  aria-label="update"
                                  className="px-2 py-0"
                                >
                                  <VisibilityIcon className="eye_icon" />
                                </IconButton>
                              </Link>
                            </div>
                          </td>


                          {/* <td>
                            <div className="action_button">
                              <Link to={`${USER_DETAIL}/${user._id}`}>
                                <IconButton
                                  aria-label="update"
                                  className="px-2 py-0"
                                >
                                  <VisibilityIcon className="eye_icon" />
                                </IconButton>
                              </Link>

                              <Switch
                                checked={user.status}
                                onChange={() =>
                                  statusUpdateHandler(user._id, user.status)
                                }
                              />
                            </div>
                          </td>
                          <td>
                            <div className="block_user_button">
                              <button
                                className="mx-4"
                                onClick={() => userLogoutHandler(user._id)}
                                // ref={buttonref}
                              >
                                Logout
                              </button>
                            </div>
                          </td> */}
                        </tr>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <NotFound
                    cols={9}
                    msg="User not found!"
                    icon={NOT_FOUND}
                    loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
            <div className="pagination-wrapper mt-4 d-flex justify-content-between align-items-center">
                                  <div className="d-flex align-items-center gap-3">
                                      <Typography variant="body2" color="textSecondary">
                                          Show:
                                      </Typography>
                                      <select
                                          value={pageLimit}
                                          onChange={(e) => handlePageLimitChange(e)}
                                          style={{ 
                                              padding: '8px 12px', 
                                              border: '1px solid #ccc', 
                                              borderRadius: '4px',
                                              fontSize: '14px',
                                              minWidth: '80px'
                                          }}
                                      >
                                          <option value={5}>5</option>
                                          <option value={10}>10</option>
                                          <option value={25}>25</option>
                                          <option value={50}>50</option>
                                          <option value={100}>100</option>
                                      </select>
                                      <Typography variant="body2" color="textSecondary">
                                           per page
                                      </Typography>
                                  </div>
                                  
                                  <div className="d-flex align-items-center gap-2">
                                      <Typography variant="body2" color="textSecondary">
                                          Showing {((activePage - 1) * pageLimit) + 1} to {Math.min(activePage * pageLimit, total)} of {total} items
                                      </Typography>
                                  </div>
                                  
                                 {total > pageLimit ? (
            <div className="pagination-wrapper">
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={pageLimit}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                  hideDisabled={true}
                />
              </div>
            </div>
          ) : null}
                              </div>
        </div>
      </div>
      {statusModal && (
        <UserStatus
          show={statusModal}
          close={closeModel}
          setListing={setUserList}
          setUserDetail={""}
          status={statusValue}
          id={statusId}
        />
      )}

      {logoutUserModel && (
        <ModalBox
          status={logoutUserModel}
          onClose={logoutCloseModel}
          title="Logout User from all Device"
          description="Do you want to logout the user from all the devices?"
          action={handleLogoutHandler}
          ref={buttonref}
        />
      )}
      <DownloadPasswordModal />
    </>
  );
};

export default DeleteUser;
